import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";

const H2 = "font-display text-lg font-semibold text-[#1A1A1A]";
const LINK = "text-[#E11D2A] underline-offset-4 transition-colors hover:text-[#F02837] hover:underline";

export default function Impressum() {
  return (
    <>
      <Seo
        title="Impressum | Sportwetten NRW GmbH"
        description="Impressum der Sportwetten NRW GmbH, Rietberg – Angaben gemäß § 5 DDG."
        path="/impressum"
      />
      <section className="bg-[#FAFAFA]" data-testid="impressum-page">
        <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 lg:px-12 lg:py-24">
          <Reveal>
            <h1 className="font-display text-3xl font-extrabold tracking-tight text-[#1A1A1A] sm:text-4xl">Impressum</h1>

            <div className="mt-8 space-y-8 text-sm leading-relaxed text-[#52525B]">
              <div>
                <h2 className={H2}>Angaben gemäß § 5 DDG</h2>
                <address className="mt-3 not-italic">
                  Sportwetten NRW GmbH
                  <br />
                  Westerwieher Straße 1
                  <br />
                  33397 Rietberg
                  <br />
                  Deutschland
                </address>
              </div>

              <div>
                <h2 className={H2}>Kontakt</h2>
                <p className="mt-3">
                  E-Mail:{" "}
                  <a href="mailto:sportwettennrw@gmail.com" className={LINK} data-testid="impressum-email-link">
                    sportwettennrw@gmail.com
                  </a>
                </p>
              </div>

              <div>
                <h2 className={H2}>Vertretung & Register</h2>
                <p className="mt-3">
                  Geschäftsführer: Daniyel F.
                  <br />
                  Handelsregister: HRB 14381
                  <br />
                  Registergericht: Amtsgericht Gütersloh
                  <br />
                  USt-IdNr.: DE460391976
                </p>
              </div>

              <div>
                <h2 className={H2}>Aufsicht & Erlaubnisse</h2>
                <p className="mt-3">
                  Zuständige Erlaubnis- und Aufsichtsbehörden für unsere Wettvermittlungsstellen:
                </p>
                <p className="mt-3">
                  <strong className="text-[#1A1A1A]">Bezirksregierung Detmold</strong> (Standort Rietberg)
                  <br />
                  Leopoldstraße 15 · 32756 Detmold ·{" "}
                  <a href="https://www.bezreg-detmold.nrw.de" target="_blank" rel="noopener noreferrer" className={LINK} data-testid="impressum-link-bezreg-detmold">
                    www.bezreg-detmold.nrw.de
                  </a>
                </p>
                <p className="mt-3">
                  <strong className="text-[#1A1A1A]">Bezirksregierung Münster</strong> (Standort Ahlen)
                  <br />
                  Domplatz 1–3 · 48143 Münster ·{" "}
                  <a href="https://www.bezreg-muenster.de" target="_blank" rel="noopener noreferrer" className={LINK} data-testid="impressum-link-bezreg-muenster">
                    www.bezreg-muenster.de
                  </a>
                </p>
                <p className="mt-3">
                  Wir sind an das länderübergreifende Spielersperrsystem OASIS angeschlossen.
                  Gesperrte Spielerinnen und Spieler sind von der Teilnahme ausgeschlossen.
                </p>
                <p className="mt-3">
                  Die Sportwetten NRW GmbH betreibt lokale Wettvermittlungsstellen und vermittelt
                  Sportwetten der Marke Tipwin. Veranstalter der vermittelten Sportwetten ist die
                  Tipwin Ltd., die über eine Erlaubnis der Gemeinsamen Glücksspielbehörde der Länder
                  (GGL) verfügt und in deren offizieller White List geführt wird.
                </p>
              </div>

              <div>
                <h2 className={H2}>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
                <p className="mt-3">
                  Daniyel F.
                  <br />
                  Westerwieher Straße 1 · 33397 Rietberg
                </p>
              </div>

              <div>
                <h2 className={H2}>Streitschlichtung</h2>
                <p className="mt-3">
                  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
                  <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className={LINK} data-testid="impressum-link-os">
                    https://ec.europa.eu/consumers/odr/
                  </a>
                  . Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
                  Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </div>

              <div>
                <h2 className={H2}>Haftung für Inhalte</h2>
                <p className="mt-3">
                  Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen
                  Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder
                  gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die
                  auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder
                  Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben unberührt.
                  Eine diesbezügliche Haftung ist erst ab dem Zeitpunkt der Kenntnis einer konkreten
                  Rechtsverletzung möglich; bei Bekanntwerden entsprechender Rechtsverletzungen entfernen
                  wir diese Inhalte umgehend.
                </p>
              </div>

              <div>
                <h2 className={H2}>Haftung für Links</h2>
                <p className="mt-3">
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen
                  Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
                  oder Betreiber verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
                  Verlinkung auf mögliche Rechtsverstöße überprüft; rechtswidrige Inhalte waren dabei
                  nicht erkennbar. Bei Bekanntwerden von Rechtsverletzungen entfernen wir derartige
                  Links umgehend.
                </p>
              </div>

              <div>
                <h2 className={H2}>Urheberrecht</h2>
                <p className="mt-3">
                  Die durch uns erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
                  Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                  Verwertung außerhalb der Grenzen des Urheberrechts bedürfen unserer schriftlichen
                  Zustimmung. Einzelne Bilder wurden mit Werkzeugen künstlicher Intelligenz erstellt
                  (siehe Datenschutzerklärung, Abschnitt „KI-generierte Inhalte“).
                </p>
              </div>

              <div>
                <h2 className={H2}>Jugend- und Spielerschutz</h2>
                <p className="mt-3">
                  Teilnahme an Sportwetten erst ab 18 Jahren. Glücksspiel kann süchtig machen.
                  Kostenlose Beratung: BZgA 0800 1372700 · check-dein-spiel.de
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
